import axios from "@/plugins/axios";

async function apiSendMessageToPartner(
  Id,
  Type,
  Message,
  Meta = null,
  UserFiles = []
) {
  const formData = new FormData();
  formData.append("Id", Id);
  formData.append("Type", Type);
  formData.append("Message", Message);
  formData.append("Meta", JSON.stringify(Meta));
  for (const UserFile of UserFiles) {
    formData.append("UserFiles[]", UserFile);
  }
  // for (const PartnerFile of PartnerFiles) {
  //   formData.append("PartnerFiles[]", PartnerFile);
  // }
  return axios.post("?Mode=General&Function=SendMessageToPartner", formData);
}

export { apiSendMessageToPartner };
